import { useEffect } from 'react';
import { applySeo, type SeoInput } from '@/lib/seo';

/** Atualiza title, meta, canonical, OG e JSON-LD da página atual. */
export function useSeo(input: SeoInput) {
  const key = JSON.stringify(input);

  useEffect(() => {
    applySeo(JSON.parse(key) as SeoInput);
  }, [key]);
}
